<template>
  <div>
    <v-card class="ma-4 mt-2">
      <v-card-text class="pa-0">
        <base-data-grid
          :ref="grid.key"
          :gridKey="grid.key"
          :dataSource="grid.dataSource"
          :columns="grid.columns"
          @on-add-click="add"
          :exportFileName="title"
          :allowGrouping="false"
          :allowFilterPanel="false"
          :title="title"
        >
          <v-row justify="center" align="center" v-if="loading">
            <div class="text-center">
             <div>
                <v-progress-circular
                  class="my-4"
                  :size="50"
                  width="5"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
              </div>
                <p class="display-1">{{ $t("Loading") }}...</p>
            </div>
          </v-row>
          <template slot="customActionTemplates" slot-scope="row">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="editData(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="success">mdi-table-edit</v-icon>
                </a>
              </template>
              <span>{{ $t("TableData") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="editItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="primary">mdi-pencil</v-icon>
                </a>
              </template>
              <span>{{ $t("Edit") }}</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <a
                  v-on="on"
                  @click.prevent="deleteItem(row.data.item)"
                  class="px-2"
                >
                  <v-icon color="red">mdi-delete</v-icon>
                </a>
              </template>
              <span>{{ $t("Delete") }}</span>
            </v-tooltip>
          </template>
          <template v-slot:action-buttons>
            <v-btn small color="primary" @click.prevent="onImport">
              {{ $t("Import") }}
              <v-icon>mdi-application-import</v-icon>
            </v-btn>
          </template>
        </base-data-grid>
      </v-card-text>
    </v-card>
    <InternalTableModal :ref="modalKey" @on-item-saved="onItemSaved" @on-table-notFound="handleTableNotFound" />
    <InternalTableDataModal :ref="internalTableDataModalKey" @on-item-saved="onItemSaved" @on-table-notFound="handleTableNotFound" />
    <InternalTableImportModal
      :ref="internalTableImportModalKey"
      @on-imported="onItemSaved"
    />
  </div>
</template>

<script>
import InternalTableService from '@/services/InternalTableService';
import InternalTableModal from '@/components/administration/internalTable/InternalTableModal';
import InternalTableDataModal from '@/components/administration/internalTable/InternalTableDataModal';
import InternalTableImportModal from '@/components/administration/internalTable/InternalTableImportModal';
import Utils from '@/ecm/common/Utils';

export default {
    components: {
        InternalTableModal,
        InternalTableDataModal,
        InternalTableImportModal,
    },
    data() {
        return {
            title: this.$t('InternalTables'),
            loading: false,
            grid: {
                key: 'internalTableGrid',
                dataSource: InternalTableService.getGrid(),
                columns: [
                    {
                        field: 'Name',
                        caption: this.$t('Name'),
                        type: 'string',
                    },
                ],
            },
            modalKey: 'modalInternalTable',
            internalTableDataModalKey: 'internalTableDataModal',
            internalTableImportModalKey: 'internalTableImportModal',
        };
    },
    computed: {
        modalInstance() {
            return this.$refs[this.modalKey];
        },
        gridInstance() {
            return this.$refs[this.grid.key];
        },
        internalTableDataModalInstance() {
            return this.$refs[this.internalTableDataModalKey];
        },
        internalTableImportModalInstance() {
            return this.$refs[this.internalTableImportModalKey];
        },
    },
    methods: {
        editData(dto) {
            this.internalTableDataModalInstance.edit(dto);
        },
        editItem(dto) {
            this.modalInstance.edit(dto);
        },
        deleteItem(dto) {
            this.$confirm(this.$t('ItemDeleteConfirmation'), {
                title: this.$t('Delete'),
                icon: 'mdi-alert',
                color: 'red',
                buttonTrueText: this.$t('Delete'),
                buttonFalseText: this.$t('Cancel'),
            }).then((res) => {
                if (res == 1) {
                    InternalTableService.delete(dto.Id).then((result) => {
                        if (result) {
                            this.gridInstance.refresh();
                            Utils.toast.success(this.$t('InternalTable') + ' ' + this.$t('DeletedSuccessfullyFem'));
                        }
                    });
                }
            });
        },
        handleTableNotFound(internalTable) {
            const message = this.$t('DeleteNotExistingUserInternalTable').replaceAll(
                '{0}',
                internalTable.name
            );
            this.$confirm(message, {
                title: this.$t('Delete'),
                icon: 'mdi-alert',
                color: 'red',
                buttonTrueText: this.$t('Delete'),
                buttonFalseText: this.$t('Cancel'),
            }).then((res) => {
                if (res == 1) {
                    InternalTableService.delete(internalTable.id).then((result) => {
                        if (result) {
                            this.gridInstance.refresh();
                            Utils.toast.success(
                                this.$t('InternalTable') +
                                    ' ' +
                                    this.$t('DeletedSuccessfullyFem')
                            );
                        }
                    });
                }
            });
        },
        add() {
            this.modalInstance.new();
        },
        onItemSaved() {
            this.loading = true;
            this.dataSource = InternalTableService.getGrid();
            this.gridInstance.refresh();
            this.loading = false;
        },
        onImport() {
            this.internalTableImportModalInstance.show();
        },
    },
};
</script>